import React from "react";
import "./nav.css"
class Search extends React.Component {

    render() {
        return (
            <div className="ui container">
            <div className="ui search search-bar">
                <div className="ui icon input">
                    <input className="prompt" type="text" placeholder="Search for artist" />
                        <i className="search icon" />
                </div>
            </div>
            </div>
        )
    }
}

export default Search;